import React from 'react';
import PropTypes from 'prop-types';

import { capitalize, isMobileUA } from 'dpl/shared/utils';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';
import { FEATURES } from 'dpl/shared/constants/features';

const IS_BOT_UA = window.__DPL_BOT_UA;
const IS_MOBILE_UA = isMobileUA();
const isAdultsDogsSearchResultsEnabled = isFeatureEnabled(
  FEATURES.REL_ADULT_DOGS_SEARCH_RESULTS
);

function capitalizeIfNoCount(text, count) {
  return IS_BOT_UA || count === null ? capitalize(text) : text;
}

export default function ItemCount({
  puppiesCount,
  breedersCount,
  resultsType
}) {
  const adjustedPuppyCount = puppiesCount > 40 ? '40+' : puppiesCount;
  const adjustedBreederCount = breedersCount > 40 ? '40+' : breedersCount;

  const puppyText = puppiesCount === 1 ? 'puppy' : 'puppies';
  const dogText = puppiesCount === 1 ? 'dog' : 'dogs';
  const breederText = breedersCount === 1 ? 'breeder' : 'breeders';

  const dogFullText = isAdultsDogsSearchResultsEnabled
    ? `${puppyText} and ${dogText}`
    : puppyText;

  const puppyTabText = IS_MOBILE_UA
    ? `${dogFullText} near you`
    : `available ${dogFullText}`;
  const breederTabText = IS_MOBILE_UA
    ? `${breederText} near you`
    : `certified ${breederText}`;

  const puppyCopy =
    !IS_BOT_UA &&
    adjustedPuppyCount &&
    `${adjustedPuppyCount.toLocaleString()} ${capitalizeIfNoCount(
      puppyTabText,
      adjustedPuppyCount
    )}`;

  const breederCopy =
    !IS_BOT_UA &&
    adjustedBreederCount &&
    `${adjustedBreederCount.toLocaleString()} ${capitalizeIfNoCount(
      breederTabText,
      adjustedBreederCount
    )}`;

  if (!puppyCopy && !breederCopy) {
    return <div />;
  }

  return (
    <div className="ItemCount overflow-hidden font-14 md:font-16 secondary">
      {resultsType === RESULTS_TYPES.PUPPIES ? puppyCopy : breederCopy}
    </div>
  );
}

ItemCount.propTypes = {
  puppiesCount: PropTypes.number,
  breedersCount: PropTypes.number,
  resultsType: PropTypes.string
};

ItemCount.defaultProps = {
  puppiesCount: 0,
  breedersCount: 0,
  resultsType: ''
};
